import styled from 'styled-components';
import Label from 'components/grid/table/components/label';
import { color, typography } from 'styles/settings';

export const ALIGN_MAP = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

export const Container = styled.div`
  box-sizing: content-box;
  border-bottom: 1px solid ${color.neutral.grayLight};
  ${typography.font.medium};
  font-size: ${typography.size.rg};
  line-height: ${typography.size.ml};
  justify-content: ${({ align }) => ALIGN_MAP[align] ?? 'center'};
  min-height: 25px;

  align-items: center;
  display: flex;
  flex-grow: 1;
  overflow: hidden; // Or flex might break
  padding: 1rem 0;

  z-index: ${({ zIndex }) => (zIndex ? zIndex : 0)};
`;

export const ActionLabel = styled(Label)`
  color: ${color.ui.textDark};
`;
